var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojiExpressionless(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 385.185C302.275 385.185 385.185 302.275 385.185 200C385.185 97.7251 302.275 14.8148 200 14.8148C97.7251 14.8148 14.8148 97.7251 14.8148 200C14.8148 302.275 97.7251 385.185 200 385.185Z",
    fill: "url(#paint0_linear_1787_8003)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.062 172.012H161.321C165.197 172.012 168.913 168.605 168.728 164.605C168.543 160.605 165.469 157.198 161.321 157.198H102.062C98.1851 157.198 94.469 160.605 94.6542 164.605C94.8394 168.605 97.9135 172.012 102.062 172.012Z",
    fill: "#161015"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.161 172.012H286.42C290.296 172.012 294.012 168.605 293.827 164.605C293.642 160.605 290.568 157.198 286.42 157.198H227.161C223.284 157.198 219.568 160.605 219.753 164.605C219.938 168.605 223.012 172.012 227.161 172.012Z",
    fill: "#161015"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.543 204.938H217.284C221.161 204.938 224.877 201.531 224.691 197.531C224.506 193.531 221.432 190.123 217.284 190.123H169.543C165.667 190.123 161.951 193.531 162.136 197.531C162.321 201.531 165.395 204.938 169.543 204.938Z",
    fill: "#161015"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1787_8003",
    x1: 200,
    y1: 14.8148,
    x2: 200,
    y2: 385.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55177,
    stopColor: "#F4C635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802758,
    stopColor: "#FFAC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC811D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiExpressionless);
export default __webpack_public_path__ + "static/media/emoji-expressionless.6d8d45dbf5feba2f2f5cca02a841d0af.svg";
export { ForwardRef as ReactComponent };